module.exports = __webpack_public_path__ + "img/boxed-6.5a516988.jpg";